export default __webpack_public_path__ + "f0bd16ae2627701945d95910179b7b78.svg";